// Point at the backend. Override with REACT_APP_API_BASE in .env.local.
export const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8080";

// View Guidelines feature is not finished yet — keep it hidden from users. Flip to true to re-enable
// the whole guideline system (work-view button + gate, Guideline ID columns, and the Guideline lookup page).
export const GUIDELINES_ENABLED = true;